<template>
	<v-container>
		<v-breadcrumbs
			:items="breadCrumbItems"
		>
			<template #divider>
				<v-icon icon="$chevronRight" />
			</template>
		</v-breadcrumbs>

		<v-row>
			<v-col>
				<v-card>
					<v-card-title>
						<v-icon
							start
							icon="$fileEdit"
						/>
						<translate>Edit PDF Template</translate>
					</v-card-title>
					<v-card-text>
						<div>
							<v-row v-if="pdfTemplate">
								<v-col cols="6">
									<v-text-field
										v-model="pdfTemplate.title"
										:label="$gettext('Title')"
										variant="outlined"
									/>
								</v-col>
								<v-col
									cols="6"
								>
									<h5>
										<translate>Available Smarty Variables</translate>
									</h5>
									<code
										v-for="variable in variables"
										:key="variable"
										style="color: purple"
									>{{ '${' + variable + '}' }}</code>
								</v-col>
							</v-row>
						</div>
						<div>
							<hr>
							<h4>HTML</h4>
							<hr>
							<textarea
								id="body"
								required
							/>
							<hr>
						</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="primary"
							variant="text"
							@click="saveTemplate"
						>
							<translate>Save</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="pdfTemplate">
			<v-col>
				<pdf-template-preview
					:id="pdfTemplate.id"
					:template-models="pdfTemplate.model"
				/>
			</v-col>
			<v-col>
				<language-changer-or-adder
					:current-language="pdfTemplate.language.name"
					post-url-change="/bo/pdftemplates/updatelanguage"
					post-url-add="/bo/pdftemplates/addlanguage"
				/>
			</v-col>
			<v-col>
				<domain-changer
					:current-domain="pdfTemplate.domain.name"
					post-url="/bo/pdftemplates/updatedomain"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>


<script>
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';
import * as ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-smarty';
import 'ace-builds/src-noconflict/theme-tomorrow';

export default {
	name: 'PdfTemplateEdit',
	data () {
		return {
			subject: '',
			pdfTemplate: null,
			variables: [],
			breadCrumbItems: [],
			editor: null,
		};
	},

	mounted () {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		this.pdfTemplateId = params.get('id');
		if (this.pdfTemplateId) {
			this.getData();
		}
	},

	methods: {
		/**
		 * Retrieve all data for the email template
		 *
		 * @returns {void}
		 */
		getData () {
			axios.get(`/api/v0/pdftemplates?id=${this.pdfTemplateId}`)
				.then(({
					data: data
				}) => {
					if (data[0]) {
						this.initialiseData(data[0]);
					}
				}).catch(() => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
				});
		},
		/**
		 * Initialise all variables using retrieved data
		 *
		 * @param {string} data - data from get response
		 * @returns {void}
		 */
		initialiseData (data) {
			this.pdfTemplate = data;

			this.variables = this.pdfTemplate.variables ? this.pdfTemplate.variables.split(',') : [];


			this.breadCrumbItems = [
				{
					title: this.$gettext('PDF Templates'),
					disabled: false,
					href: '/bo/pdftemplates'
				},
				{
					title: this.pdfTemplate.title,
					disabled: true,
				},
			];
			this.editor = ace.edit('body');
			this.editor.setTheme('ace/theme/tomorrow');
			this.editor.getSession().setMode('ace/mode/smarty');
			this.editor.resize();
			this.editor.setValue(this.pdfTemplate.body, 1);
		},

		/**
		 * Save the changes made to the email template and reload the page
		 *
		 * @returns {void}
		 */
		saveTemplate () {
			axios.put(`/api/v0/pdftemplates/${this.pdfTemplateId}`, {
				id: this.pdfTemplateId,
				title: this.pdfTemplate.title,
				body: this.editor.getValue(),
			}).catch((error) => {
				displayError(error);
			}).finally(() => {
				window.location.reload();
			});
		},
	}
};
</script>
